 


/**
 * Quick Data Helper to get ALl AOI & Labels
 * @mixin
 */
var PoiDataHelper = {
    "builder": new SumoPredicateBuilder(),
    "getAll":function(){
        //query 
        var DATA = 45;
        this.builder.Clear();
        this.builder.AddNewExpressionConditional('PoiFlag',1, false, mRelationalOperatorEnum.Is(), mLogicalOperatorEnum.And());
        if(Boolean(AgentHelper.getPermissionValueById(DATA))){
            // 
            this.builder.AddNewExpressionConditional('MakePublic',[0,1], false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And()); 
        }else {
            // If you dont have data Access but you have ORI you can see it.. 
            this.builder.AddNewExpressionConditional('MakePublic',[0,1], false, mRelationalOperatorEnum.In(),mLogicalOperatorEnum.And());
            this.builder.AddNewExpressionConditional('OrganizationId',gUserDetails.OrganizationIds, false,  mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        }
        // Filter Organization access
        var pointsOfInterest = query(getDataItems('Zones'),this.builder.RootExpression);
        this.builder.Clear();
        return pointsOfInterest;
    },
    "initLayersOnMap":function(gMap){
        function poiMarkerHoverOut(aSender){
            gMap.hideInfo();
        }
        function poiMarkerHover(aSender){
            var POIData = aSender.sumoData, 
            lEnrollee =getDataItem(mEnrolleesData.OffenderCurrentId,'Enrollees');
            lTimeZone = getTimezone(lEnrollee.TimeZoneId, 'TimeZone');
           if (!isNullOrUndefined(POIData) && POIData.Id !== -1) {
            gMap.geocode(POIData.CenterLatitude.toString() + ',' + POIData.CenterLongitude.toString(), 
                function reverseGeoCode_OnSuccess(lResult) {
                    var Address = lResult ? lResult['formated_address'] : '',
                    Organization = getDataItem(POIData.OrganizationId,'Organizations'),
                    POI_AOI = 2;
                    var typeId = POIData.Type === POI_AOI ? 'Area of Interest' : 'Label';
                    // TODO: Add translation fn 
                    var html = [
                        '<div style="line-height:normal;">',
                            '<h4> Name:',POIData.Name,'</h4>',
                            '<div>',typeId,'</div>',
                            '<div> Organization: ',Organization.Name,'</div>',
                            '<span style="white-space:nowrap;"> ' , localizeText('cEnrolleeAddress') , ': ' , Address , ' </span>',
                            '<div> Created Date: ',displayEnrolleeTimeZone(POIData.CreatedDateUTC, lTimeZone),'</div>',
                        '</div>'];
                gMap.showInfo(aSender, html.join(' '), POIData.CenterLatitude, POIData.CenterLongitude);
                });
           }
        }
        gMap.layerAdd('PointOfInterestMarker', {
            'renderType': 'marker',
            'doesPlayback': true,
            'isVisible': true,
            'markerImageSize': { 'width': 70, 'height': 70 },
            'clickEventHandler': function(aSender,aData){
                gMap.setCenter(aSender.position.lat(),aSender.position.lng())
                gMap.zoom(18);
            },
            'zIndexStart': 1000000,
            'hoverEventHandler': function(aSender,aData){
                poiMarkerHover(aSender);
            },
            'hoverOutEventHandler': function(aSender,aData){
                poiMarkerHoverOut(aSender);
            },
        });
        gMap.layerAdd('PointOfInterestShape', {
            'renderType': 'geometry',
            'doesPlayback': false,
            'isVisible': true,
            'clickEventHandler': null,
            'zIndexStart': 0,
        });
    },
    "renderOnMap":function(gMap){
        gMap.layerSetDataSource('PointOfInterestMarker', []);
        gMap.layerSetDataSource('PointOfInterestShape', []);
        var DataList = this.getAll();
        gMap.layerSetDataSource('PointOfInterestMarker', veritracks.mapping.preparePointOfInterestMarkerData(DataList));
        gMap.layerSetDataSource('PointOfInterestShape', veritracks.mapping.preparePointOfInterestShapeData(DataList));
    }
};
 /**
     * MapPointOfInterestModal
     * @namespace
     * @param type string  optional, will determine the template render available options are "label" or "AOI" or "Zone" in a given map
     * @param latLng google.maps.LatLng  coordinates to point the Point of Interest
     * @param mapObject sumo.maps.GoogleMapControl  map instanciated from GoogleMapControl class 
     */
function MapPointOfInterestModal(aType, latLng,aMap){
        this.poi = null;
        var POI_AOI = 2, POI_LABEL = 1, MAX_RADIUS_FT = 5280;
        var PoiItem = new PointOfInterestDataObject();//POI
        var validationObj = new Validator('uVeritracksCustomPopup', mRegexValidation);  
        var gMap = aMap, isGeoCoded = false,
        type = aType.toLowerCase(),
        typeOptions = {'aoi':POI_AOI,'label':POI_LABEL};
        typeId =  typeOptions[type];
        PoiItem.Type = typeId;
        setMap(aMap);// we set the map 
        function onPointOfInterestShapeChange(e){
            PoiItem.CenterLatitude = e.center.lat();
            PoiItem.CenterLongitude = e.center.lng();
            reverseGeoCodeOnMap();
            var Radius = Math.round(sumo.geo.conversion.metersToFeet(e.getRadius()));
            if(Radius > MAX_RADIUS_FT){
                Radius = MAX_RADIUS_FT; 
                mActivityNotification.addNotification(localizeWrapper('cAnalysisPointOfInterestRadiusLarge'));
            }
            // 1 mile
            PoiItem.Radius = Radius;
            document.getElementById('poiRadius').value = Radius;
            gMap.layerSetDataSource('PointOfInterestShapeEdit', []);
            gMap.layerSetDataSource('PointOfInterestMarkerEdit', []);
            gMap.layerSetDataSource('PointOfInterestShapeEdit', veritracks.mapping.preparePointOfInterestShapeData([PoiItem]));
            gMap.layerSetDataSource('PointOfInterestMarkerEdit', veritracks.mapping.preparePointOfInterestMarkerData([PoiItem]));

        }
        function setMap(googleMapControl){
            gMap = googleMapControl;
            if(!gMap || gMap === null || typeof gMap === "undefined"){
                throw ('MapPointOfInterestModal requires the sumo.maps.GoogleMapControl Instance defined');
            }
            var markerOptions = {1:"Label",2:"AOI"},
                iconName = markerOptions[typeId];
            var IconId = IconHelper.getIconIdByName(iconName)
            if(!isNullOrUndefined(mEnrolleesIcon['icons'][IconId]['IconValue'])){
                lMarker = veritracks.mapping.iconGenerator.generateMapMarker(mEnrolleesIcon.icons[IconId]['IconValue'])
            }
            lLayerOptions = {
                'renderType': 'marker',
                'doesPlayback': false,
                'isVisible': true,
                'clickEventHandler': null,
                'zIndexStart': 1000000,
                'markerImageSize': { 'width': 70, 'height': 70 },
            };
            gMap.layerAdd('PointOfInterestMarkerEdit', lLayerOptions);
            gMap.layerAdd('PointOfInterestShapeEdit', {
                'renderType': 'geometry',
                'doesPlayback': false,
                'isVisible': true,
                'clickEventHandler': null,
                'zIndexStart': 1000000,
                'shapeChangeHandler': onPointOfInterestShapeChange,
            });
        }
        this.getMap = function(){
            return gMap;
        }  
        
        this.modal = function (){
            
        }
        //Logic 
        var poiModalForm = new CustomPopup({
                'id':'uVeritracksCustomPopup',
                'cssUrl':'Scripts/Controls/poi/PointOfInterest.css', 
                'template':htmlTemplate()
            });
        // events
        poiModalForm.onLoad =  function onModalFormLoad(){
            preFillFormData();
            gMap.reverseGeocode(latLng.lat(),latLng.lng(),function(address){
                AddressHelper.set(address);
                PoiItem.Description = location.Description;
                validationObj.scan();
            })
            gMap.zoom(18);
            gMap.setCenter(latLng.lat(),latLng.lng());
            setPointOfInterest(PoiItem)
            document.getElementsByName('.btn-save').disabled  = true;
        };
        function onModalFormClosed(){
            gMap.layerSetDataSource('PointOfInterestMarkerEdit',[]);
            gMap.layerSetDataSource('PointOfInterestShapeEdit',[]);
            disposeAll();
        }
        poiModalForm.onClose = onModalFormClosed;
        // show form
        poiModalForm.open().result(function onSave(){
                save(PoiItem);// Save Point of Interest
            },function onCancel(){
            
            });

        var eventListeners = {};
        function save(PoiItem){
            PoiItem.Description = document.getElementById('poiAddressDescription').value;
            PoiItem.Name = document.getElementById('poiName').value.trim();
            PoiItem.UpdatedByAppUserId = gUserDetails.UserId;
            var OrganizationId = parseInt(document.getElementById('poiOrganizationId').value);
            var AgentId = getMyAgentsIdByOrganizationId(gUserDetails.UserId,OrganizationId);
            PoiItem.AgentId = AgentId.length ? AgentId[0] : 1; // Defaults
            PoiItem.Scope = 1;
            PoiItem.addresTypeId = -1;
            PoiItem.PoiFlag = 1;
            PoiItem.Radius = document.getElementById('poiRadius').value;
            veritracks.mapping.saveZone(PoiItem, null, null, function(aZone, aData){
                poiModalForm.close();
                PoiDataHelper.renderOnMap(gMap);
            });
        }
        // init
        function setPointOfInterest(_PoiItem){
            gMap.setCenter(_PoiItem.CenterLatitude,_PoiItem.CenterLongitude)
            gMap.layerSetDataSource('PointOfInterestMarkerEdit', veritracks.mapping.preparePointOfInterestMarkerData([_PoiItem]));
            gMap.layerSetDataSource('PointOfInterestShapeEdit', veritracks.mapping.preparePointOfInterestShapeData([_PoiItem]));
        }
        function preFillFormData(){
            PoiItem.Radius = 150.00;
            PoiItem.CenterLatitude = latLng.lat();
            PoiItem.CenterLongitude = latLng.lng();
            // set isGeoCoded 
            isGeoCoded = true;
            PoiItem.PoiFlag = 1;
            PoiItem.MakePublic = 0;
            document.getElementById('poiName').value = "";
            document.getElementById('poiRadius').value = PoiItem.Radius;
           
            populateEditView(this.poi, [
                { 'Id': 'Name', 'Type': 'Text', 'DataSource': '', 'DataValueField': 'Name', 'DataTextField': 'Name' },
                { 'Id': 'OrganizationId', 'Type': 'Dropdown', 'DataSource': AgentHelper.getUserOrganizations(), 'DataValueField': 'Id', 'DataTextField': 'Name' },
                { 'Id': 'TypeId', 'Type': 'Dropdown', 'DataSource': getDataItems('ZoneType'), 'DataValueField': 'Id', 'DataTextField': 'Description' },
            ], {}, 'poi', '');
            ValidateSaveButton();
            var preselectEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId,'Enrollees');
            PoiItem.OrganizationId = preselectEnrollee.OrganizationId;
            document.getElementById('poiOrganizationId').value = preselectEnrollee.OrganizationId;
            eventListeners['poiId'] = EventHelper.on('#pointOfInterestId','keyup',function(event){
                var closest = event.target.closest('.input'),
                    geoCodedValidation = event.target.closest('.poiAddressMustGeocode');
                if (closest && document.querySelector('#pointOfInterestId').contains(closest)) {
                    ValidateSaveButton();
                }
                if (geoCodedValidation && document.querySelector('#pointOfInterestId').contains(geoCodedValidation)) {
                    isGeoCoded = false;
                    ValidateSaveButton();
                }
            });
            eventListeners['isVisible'] = EventHelper.on('#poiIsVisible','change',function(e){
                PoiItem.MakePublic = this.checked ? 1 : 0;
            });
            PoiItem.OrganizationId = parseInt(document.getElementById('poiOrganizationId').value);
            eventListeners['organization'] = EventHelper.on('#poiOrganizationId','change',function(e){
                PoiItem.OrganizationId = parseInt(this.value);
            });
            eventListeners['locate'] = EventHelper.on('#uPoiLocateButton','click',function(e){
                geolocateOnMap();
                
            });
            eventListeners['poiRadius'] = EventHelper.on('#poiRadius','keyup',function(event){
                PoiItem.Radius = Math.round(this.value);
                gMap.layerSetDataSource('PointOfInterestShapeEdit', []);
                gMap.layerSetDataSource('PointOfInterestShapeEdit', veritracks.mapping.preparePointOfInterestShapeData([PoiItem]));
            });
        }
        function disposeAll(){
            for(var k in eventListeners){
                eventListeners[k].dispose();
            }
            eventListeners = null;
            type = null;
            PoiItem =  null;
        }
         /**
         * ValidateSaveButton@ 
         * Validations before save
         */
        function ValidateSaveButton(){
            document.getElementById('poiSaveButton').disabled = !validationObj.IsValid() || !isGeoCoded ;
        }
        /**
         * geolocateOnMap@ 
         * locate address on given map and clean elements
         */
        function geolocateOnMap(){
            // mEnrolleesData.EnrolleeAddressGeocodeMatch = true;
            if(gMap){
                gMap.locate(AddressHelper.getFull(), function(e,googleAddressObj){
                    var location = new Address(googleAddressObj);
                    location.Zip = location.ZipCode;
                    PoiItem.CenterLatitude = location.Latitude;
                    PoiItem.CenterLongitude = location.Longitude;
                    PoiItem.Description = location.Description;
                    PoiItem.PoiFlag = 1;
                    isGeoCoded = location.Street1.trim() === "" ? false : true;
                    AddressHelper.set(location);
                    setPointOfInterest(PoiItem);
                    ValidateSaveButton();    
                });
            }
        }
        function reverseGeoCodeOnMap(){
            gMap.geocode(PoiItem.CenterLatitude.toString()+','+PoiItem.CenterLongitude.toString(), function(address,status,params){
                var location = new Address(address[0]);
                location.Zip = location.ZipCode;
                PoiItem.CenterLatitude = location.Latitude;
                PoiItem.CenterLongitude = location.Longitude;
                PoiItem.Description = location.Description;
                PoiItem.PoiFlag = 1;
                isGeoCoded = location.Street1.trim() === "" ? false : true;
                AddressHelper.set(location);
                ValidateSaveButton();    
            });
        }
        
        
        /**
         * htmlTemplate
         */  
        function htmlTemplate(){
            var title = {
                "label":"New Label (location)",
                "aoi":"New Area Of Interest"
            };
            
            return [
                '<div class="poi__header">',
                    '<div class="title" >',title[type],'</div><button type="button" class="btn-link btn-close"></button>',
                '</div>',
                '<div id="pointOfInterestId" class="poi__body">',
                    '<div class="poi__form--field">',
                        '<span class="label">Name</span>',
                        '<input  id="poiName" type="text" validate="" class="input Validate field ValidateRequired ValidateNotEmpty" />',
                    '</div>',
                    '<div class="poi__form--field">',
                        '<span class="label">Organization</span>',
                        '<select id="poiOrganizationId" class="listenOnChange field"></select>',
                    '</div>',
                    '<div class="poi__form--field">',
                        '<span class="label">Radius (ft)</span>',
                        '<input type="text" id="poiRadius" class=" input field Validate ValidateRequired ValidateInteger ValidateSuccess" />',
                    '</div>',
                    '<div  class="poi__form--field">',
                        '<h3 class="subtitle">',localizeWrapper('cEnrolleeAddress'),'</h3> ',
                        '<div class="subtitle Clickable IconButton LocateButton FloatRight" id="uPoiLocateButton"   title="',localizeText('cAddressGeocode'),'"></div>',
                    '</div>',
                    '<div class="poi__form--field">',
                        '<span class="label"',localizeWrapper('cEnrolleeAddressStreet1'),'</span>',
                        '<input type="text" id="poiAddressStreet1" class="input field Validate ValidateRequired ValidateNotEmpty poiAddressMustGeocode  Validate100Length" />',
                    '</div>',

                    '<div class="poi__form--field">',
                        '<span class="label"',localizeWrapper('cEnrolleeAddressStreet2'),'</span>',
                        '<input type="text" id="poiAddressStreet2" class="input field poiAddressMustGeocode Validate  Validate100Length" />',
                    '</div>',
                    '<div class="poi__form--field">',
                        '<span class="label"',localizeWrapper('cEnrolleeAddressCity'),'</span>',
                        '<input type="text" id="poiAddressCity" class="input field Validate poiAddressMustGeocode ValidateNotEmpty ValidateRequired  Validate50Length" />',
                    '</div>',
                    '<div class="poi__form--field">',
                        '<span class="label"',localizeWrapper('cEnrolleeAddressState'),'</span>',
                        '<input type="text" id="poiAddressState" class="input field Validate ValidateRequired ValidateNotEmpty " />',
                    '</div>',
                    '<div class="poi__form--field">',
                        '<span class="label"',localizeWrapper('cEnrolleeAddressZipCode'),'</span>',
                        '<input type="text" id="poiAddressZip" class="field Validate poiAddressMustGeocode ValidateRequired  ValidateNotEmpty  Validate10Length" />',
                    '</div>',
                    '<div class="poi__form--field">',
                        '<span class="label"',localizeWrapper('cEnrolleeAddressCountry'),'</span>',
                        '<input type="text" id="poiAddressCountry" class="input field Validate ValidateRequired ValidateNotEmpty poiAddressMustGeocode  Validate255Length" value="USA" />',
                        '<input type="hidden" id="poiAddressLatitude" value="0.0" />',
                        '<input type="hidden" id="poiAddressLongitude" value="0.0" />',
                        '<input type="hidden" id="poiAddressDescription" value="" />',
                    '</div>',
                    '<div class="poi__form--field">',
                        '<span class="label">Make Public?</span>',
                        '<input type="checkbox" id="poiIsVisible" class="field" />',
                    '</div>',
                '</div>',
                '<div class="poi__footer">',
                    '<button id="poiSaveButton" type="button" class="poi__footer--save btn-link btn-save">Save</button>',
                '</div>',
            ].join(' ').toString();
        }
        return this;
    }

if (typeof exports !== 'undefined') {
    module.exports = {
        "MapPointOfInterestModal":MapPointOfInterestModal,
        "PoiDataHelper":PoiDataHelper};
}
